import { licenses } from '@/images/licenses';

export default function AboutSection() {
  return (
    <section id="licenses" className="py-20 md:py-28 bg-carland-cream">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* License Badges */}
          <div className="flex-1 w-full reveal spring-right">
            <div className="grid grid-cols-3 gap-4 md:gap-6">
              {licenses.map((license) => (
                <div
                  key={license.id}
                  className="bg-white rounded-2xl p-4 md:p-6 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1"
                >
                  {/* License Image */}
                  <div className="w-full aspect-[3/4] rounded-xl overflow-hidden bg-carland-cream/50 mb-3 md:mb-4">
                    <img
                      src={license.image}
                      alt={license.name}
                      className="w-full h-full object-contain p-2"
                      loading="lazy"
                      decoding="async"
                      onError={(e) => {
                        const target = e.currentTarget;
                        if (target.src !== license.fallback) {
                          target.src = license.fallback;
                        }
                      }}
                    />
                  </div>
                  {/* License Name */}
                  <p className="text-carland-dark font-bold text-xs md:text-sm">{license.shortName}</p>
                  <p className="text-carland-muted text-[10px] md:text-xs mt-0.5">{license.name}</p>
                </div>
              ))}
            </div>
            {/* Help text */}
            <p className="text-center text-carland-muted text-[10px] mt-4">
              برای مشاهده اصل مجوزها روی هر گزینه کلیک کنید
            </p>
          </div>

          {/* Text */}
          <div className="flex-1 text-right reveal spring-left">
            <h2 className="text-3xl md:text-5xl font-black text-carland-dark leading-tight mb-6">
              از سال ۱۳۹۳
              <br />
              پل ارتباطی میان
              <br />
              استعدادها و صنعت
            </h2>
            <div className="space-y-4 text-carland-muted text-sm md:text-base leading-relaxed mb-8">
              <p>
                کارلند از سال ۱۳۹۳ با ۱۳ سال سابقه درخشان در زمینه کاریابی و استخدام، به عنوان یکی از معتبرترین 
                موسسات کاریابی کشور شناخته می‌شود. ما با بهره‌گیری از تیمی مجرب و متخصص، 
                همواره در تلاش بوده‌ایم تا بهترین فرصت‌های شغلی را برای کارجویان فراهم کنیم.
              </p>
              <p>
                کلیه خدمات ما تحت نظارت مراجع قانونی و با مجوزهای رسمی از وزارت کار، وزارت ارتباطات 
                و دارای نماد اعتماد الکترونیکی (اینماد) ارائه می‌شود. 
                ما متعهد به ایجاد امنیت شغلی پایدار برای تمامی مراجعین خود هستیم.
              </p>
              <div className="pt-4 space-y-2">
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-carland-accent text-lg"></i>
                  </div>
                  <span className="text-carland-dark font-medium text-sm">
                    تهران، خیابان ولیعصر، مرکز تجاری میلاد، طبقه ۱۵، واحد ۱۵۰۲
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-carland-accent text-lg"></i>
                  </div>
                  <span className="text-carland-dark font-medium text-sm">carland@gmail.com</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-carland-accent text-lg"></i>
                  </div>
                  <span className="text-carland-dark font-medium text-sm">۰۲۱-۱۲۳۴۵۶۷۸</span>
                </div>
              </div>
            </div>
            <a
              href="#contact"
              className="px-8 py-3.5 rounded-full bg-carland-dark text-white font-semibold text-sm hover:bg-carland-darker transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center gap-2 hover:-translate-y-0.5"
            >
              <span>مشاوره رایگان</span>
              <i className="ri-arrow-left-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}